import LogoGenerator from '@utils/logo-generator'

class PortalAvatar {
  avatar?: string
  text: string

  constructor(avatar?: string, text?: string) {
    this.avatar = avatar || ''
    this.text = text || ''
  }

  get Avatar() {
    return (
      this.avatar
        ?.replace('https://www.tinygraphs.com/', 'https://tinygraphs.berlitz-platforms.io/')
        ?.replace('https://tinygraphs.com/', 'https://tinygraphs.berlitz-platforms.io/')
        ?.replace('http://tinygraphs.com/', 'https://tinygraphs.berlitz-platforms.io/') || ''
    )
  }

  get Avatar2() {
    return LogoGenerator.getLogoDataUrl({ text: this.text, pattern: 'space-invaders' })
  }

  get IsTinyGraphs() {
    return this.Avatar?.includes('tinygraphs')
  }
}

export default PortalAvatar
